import React from 'react';

function ChangePassword() {
    return (
        <div>
            <div className="int-container">
                <div class="container">
                    <div class="form-container">
                        <div class="form-group">
                            <h3 style={{ color: "#f19f1f", width: "100%", textAlign: "center" }}>Change Password</h3>
                        </div>
                        <div class="form-group">
                            <input type="text" placeholder="Enter Old Password" class="form-control" />
                        </div>
                        <div class="form-group">
                            <input type="text" placeholder="Enter New Password" class="form-control" />
                        </div>
                        <div class="form-group">
                            <input type="text" placeholder="Confirm New Password" class="form-control" />
                        </div>
                        <div class="form-group">
                            <button class="btn btn-block btn-primary">Submit</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ChangePassword;